import { api } from './client';
import { handleRequest } from './request';

export const login = (credentials) =>
  handleRequest(() => api.post('/login', credentials), 'Erro ao autenticar');

export const logout = () =>
  handleRequest(() => api.post('/logout'), 'Erro ao sair');

export const checkUser = () =>
  handleRequest(() => api.get('/me'), 'Erro ao verificar usuário');

export const saveUserProfiles = (perfisSelecionados) =>
  handleRequest(() => api.post('/user_profiles', { perfisSelecionados }), 'Erro ao atualizar');